export class RevenueReportSortField {
    static readonly Revenue: number = 0;
    static readonly Publisher: number = 1;
    static readonly Country: number = 2;
    static readonly Completes: number = 3;
    static readonly RPE: number = 4;
}


// WEBPACK FOOTER //
// ./src/app/reports/revenue-report/revenue-report-sort.enum.ts